<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :max-height="'60vh'"
      :src="require('@/assets/calculator.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-img
            :src="require('@/assets/IFEA-Treuhand-GmbH-LOGO-INLINE.png')"
            contain
            max-width="1200"
            width="100%"
          />
          <base-heading
            title="In Finanzen Eins A"
            :override="true"
            weight="light"
            mobile-size="heading"
          />
          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          />
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '40vh' : '20vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
